import "../../shared/styles/index.css";
import iconOne from "../../assets/icons/top_indore_college_in_india/icon_one.webp";
import iconTwo from "../../assets/icons/top_indore_college_in_india/icon_two.webp";
import iconThree from "../../assets/icons/top_indore_college_in_india/icon_three.webp";
import iconFour from "../../assets/icons/top_indore_college_in_india/icon_four.webp";

const Card = () => {
  return (
    <div className="card-container">
      {/*  add two value  */}
      <div className="card-group-container">
        <div className="card-each-container">
          <img src={iconOne} alt="" />

          <div className="card-text-container">
            <p className="card-text-container-heading">
              State-of-the-art Infrastructure
            </p>
            <p className="card-text-container-title">
              Every student receives tailored guidance from the Career Resource
              Center and industry mentors to ensure optimal placement outcomes.
            </p>
          </div>
        </div>
        <div className="card-each-container">
          <img src={iconTwo} alt="" />

          <div className="card-text-container">
            <p className="card-text-container-heading">
              Industry-Aligned Curriculum
            </p>
            <p className="card-text-container-title">
              Programs co-developed with industry partners to reflect real-world
              demands and future business trends.
            </p>
          </div>
        </div>
      </div>

      {/*  add two value  */}
      <div className="card-group-container">
        <div className="card-each-container">
          <img src={iconThree} alt="" />

          <div className="card-text-container">
            <p className="card-text-container-heading">
              100% Placement Assistance
            </p>
            <p className="card-text-container-title">
              Learn from educators with 20+ years of academic and industry
              expertise, with numerous published research papers and consultancy
              credentials.
            </p>
          </div>
        </div>
        <div className="card-each-container">
          <img src={iconFour} alt="" />

          <div className="card-text-container">
            <p className="card-text-container-heading">
              Innovation-Driven Learning
            </p>
            <p className="card-text-container-title">
              Engage in cutting-edge research in AI, blockchain, consumer
              analytics, and marketing strategies—starting from graduation
              level.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
